<div class="flex flex-row flex-wrap items-center gap-2">
  <ng-container *ngFor="let label of labels">
    <ion-icon
      *ngIf="label?.image"
      [class.small]="size === 'small'"
      [class.large]="size === 'large'"
      [src]="label?.image"
      #iconTooltip="tooltip"
      [tooltip]="label?.description"
    ></ion-icon>
    <ion-badge
      *ngIf="!label?.image"
      [class.small]="size === 'small'"
      [class.large]="size === 'large'"
      class="flex flex-row items-center justify-center"
      [class.finishing]="label?.type === 'finishing'"
      #badgeTooltip="tooltip"
      [tooltip]="label?.description"
      >{{ label?.label }}
    </ion-badge>
  </ng-container>
</div>
